function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GibraltarFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M0 3h24v18H0z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C51918",
      fillRule: "evenodd",
      d: "M0 15h24v6H0v-6Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#DB000B",
      fillRule: "evenodd",
      d: "M12.344 3.95h-1.422v1.271h.702l-.05 3.497H9.5v-1.59h.71v-1.27h-1.42v.635h-.71v-.636H6.658V7.13h.71v1.589H5.872v1.271H7.37h-.788v3.815h-.71v1.271h13.5v-1.271H17.95V9.989h1.421V8.718H17.98l.035-1.59h.724v-1.27h-1.42v.635h-.711v-.636h-1.421V7.13h.696l-.035 1.589h-2.142l.05-3.497h.72V3.95h-1.421v.636h-.71V3.95ZM9.5 9.99h2.055H9.5Zm6.318 0h-2.132 2.132Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#272727",
      fillRule: "evenodd",
      d: "M8.712 13.268a.829.829 0 1 1 1.658 0v1.37H8.712v-1.37ZM14.79 13.268a.829.829 0 1 1 1.658 0v1.37h-1.657v-1.37ZM11.475 12.939c0-.58.47-1.05 1.05-1.05h.11c.58 0 1.05.47 1.05 1.05v2.25h-2.21v-2.25Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E8AA00",
      fillRule: "evenodd",
      d: "m12.992 14.398-.136.249-.252-.377-2.07 1.387 2.307 1.098 2.035-1.33-1.884-1.027Zm-.945 1.148.665-.446.704.383-.633.413-.736-.35ZM11.368 18.4h1.106v1.1h-1.106v-1.1Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E8AA00",
      fillRule: "evenodd",
      d: "M12 16.5h1.312v3H12v-3Z",
      clipRule: "evenodd"
    })]
  })]
}));
//# sourceMappingURL=Gibraltar.js.map